import { startCase } from 'lodash';

export enum AccountStatus {
  ACTIVE = 'ACTIVE',
  PENDING_CLOSURE = 'PENDING_CLOSURE',
  FROZEN = 'FROZEN',
  BLOCKED = 'BLOCKED',
  CLOSED = 'CLOSED',
}

const LABELS: Record<string, string> = {
  uuid: 'User ID',
};
export const getLabel = (key: string) => {
  if (key in LABELS) return LABELS[key];
  return startCase(key);
};
export interface SearchData {
  country?: string;
  freeText?: string;
  includeDetails?: boolean;
}

export interface ProfileHistory {
  createdAt: Date;
  changeReason?: string;
  changedBy?: string;
  record: Record<string, any>;
}

export interface KycHistory {
  createdAt: Date;
  changeReason?: string;
  changedBy?: string;
  record: Record<string, any>;
}

export interface OnboardingHistory {
  createdAt: Date;
  questions: Record<string, any>;
  answers: Record<string, string[]>;
}

export interface ProfileHistoryResponse {
  profileHistory: ProfileHistory[];
  kycHistory: KycHistory[];
  onboardingHistory: OnboardingHistory[];
}
